module.exports = __webpack_public_path__ + "static/media/blog1.553b8696.jpg";